import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import PropTypes from 'prop-types'

const UserModal = ({ open, user, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='view-edit-user-title'
      aria-describedby='view-edit-user-description'
    >
      <DialogTitle 
        id='view-edit-user-title' 
        sx={{ 
          display: 'flex', 
          color: '#27417A',
          fontWeight: 'bold' 
        }}
      >
        <AccountCircleIcon sx={{ fontSize: 36 }} />
        View / Edit User
      </DialogTitle>
      <DialogContent>
        <Box
          component='form'
          onSubmit={(event) => event.preventDefault()}
          noValidate
          autoComplete='off'
          sx={{
            mt: 1
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <TextField 
                error={false}
                id='firstName'
                name='firstName'
                label='First Name'
                value={user.givenName}
                onChange={() => console.log('changed')}
                onBlur={() => console.log('blured')}
                // helperText='helper text'
                fullWidth
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField 
                error={false}
                id='lastName'
                name='lastName'
                label='Last Name'
                value={user.surname}
                onChange={() => console.log('changed')}
                onBlur={() => console.log('blured')}
                // helperText='helper text'
                fullWidth
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField 
                error={false}
                id='email'
                name='email'
                label='Email'
                value={user.mail}
                onChange={() => console.log('changed')}
                onBlur={() => console.log('blured')}
                // helperText='helper text'
                fullWidth
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField 
                error={false}
                id='title'
                name='title'
                label='Title'
                value={user.jobTitle}
                onChange={() => console.log('changed')}
                onBlur={() => console.log('blured')}
                // helperText='helper text'
                fullWidth
              />
            </Grid>
            {/* <Grid item md={6} xs={12}>
              <TextField 
                error={false}
                id='role'
                name='role'
                label='Role'
                value={user.role}
                onChange={() => console.log('changed')}
                onBlur={() => console.log('blured')}
                // helperText='helper text'
                fullWidth
              />
            </Grid> */}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          variant='contained' 
          color='secondary' 
          onClick={onClose}
        >
            Close
        </Button>
        <Button 
          variant='contained' 
          sx={{
            backgroundColor: '#3A6DAA'
          }} 
          onClick={onClose} 
          autoFocus
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UserModal.propTypes = {
  open: PropTypes.bool,
  user: PropTypes.shape({
    givenName: PropTypes.string,
    surname: PropTypes.string,
    mail: PropTypes.string,
    jobTitle: PropTypes.string
  }),
  onClose: PropTypes.func
}

export default UserModal